export default {
      id: "i-dzen-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-dzen",
      toString: function () {
        return this.url;
      }
    }